import React from 'react';
import Project from './Project';
import projects from '../consts/projects';

const ProjectList = ({ title, filter = () => true, limit = projects.length, t }) => {
  const filteredProjects = projects
    .filter(filter)
    .slice(0, limit)
    .sort((a, b) => a.hasImage - b.hasImage);

  if (filteredProjects.length === 0) return null;

  return (
    <>
      {title && (
        <div>
          <h2 className="h2">{title}</h2>
        </div>
      )}
      <div className="project-list">
        {filteredProjects.map(project => (
          <Project key={project.id} id={project.id} t={t} />
        ))}
      </div>
    </>
  );
};

export default ProjectList;
